const SendIcon = ({ color = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill={color}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.444 4.31755C4.39964 6.69157 0.235955 8.66188 0.191327 8.69602C0.1467 8.73019 0.0833707 8.81435 0.0505535 8.88307C0.00167241 8.98553 -0.00666851 9.03034 0.00423885 9.13178C0.0193998 9.27267 0.106801 9.43303 0.205015 9.50009C0.334406 9.58846 5.11558 11.7588 5.14046 11.7404C5.15425 11.7303 7.1545 10.1542 9.58549 8.23799C12.0165 6.32182 14.1552 4.63603 14.3381 4.49181C14.66 4.23813 14.6341 4.2653 13.5421 5.3274C12.9213 5.9312 11.0412 7.74817 9.36413 9.36515L6.31494 12.3051L6.38184 12.3379C6.41862 12.3559 7.78696 12.9822 9.42259 13.7297C12.3137 15.0508 12.4003 15.0887 12.5356 15.0882C12.711 15.0875 12.845 15.0307 12.9477 14.9133C13.0097 14.8425 13.6492 13.3168 15.994 7.64491C17.6262 3.69661 18.974 0.423725 18.9889 0.371845C19.0423 0.186573 18.8959 -0.00252739 18.7011 2.55633e-05C18.6368 0.000891744 16.3336 1.07512 9.444 4.31755ZM6.31803 14.5714C6.31803 15.6808 6.32098 15.7671 6.36145 15.8395C6.38533 15.8822 6.44132 15.9359 6.48585 15.9588C6.64059 16.0384 6.68653 16.0223 7.13183 15.7326C8.52821 14.8241 8.90279 14.5741 8.88853 14.5598C8.87385 14.5452 6.80763 13.5948 6.46655 13.4459L6.31803 13.381V14.5714Z"
        fill={color}
      />
    </svg>
  );
};

export default SendIcon;
